import { useState } from 'react'
import arrowRight from '../../../../assets/icons/arrowRight.svg'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../redux'
import libertyLakeSlice from '../../../../redux/slice/libertyLake.slice'
import { LibertyLakeFamilyInfo } from '../../../../types/libertyLakeV2'

const Step3 = () => {
  const dispatch: AppDispatch = useDispatch()
  const { config, familyInfo } = useSelector((state: RootState) => state.libertyLake)

  const [occupationDropdown, showOccupationDropdown] = useState(false)
  const [earlyPayDropdown, showEarlyPayDropdown] = useState(false)

  const updateFamilyInfo = (updates: Partial<LibertyLakeFamilyInfo>) => {
    dispatch(libertyLakeSlice.actions.setFamilyInfo({ ...familyInfo, ...updates }))
  }

  const occupationOptions = config ? Object.keys(config.discounts.occupational) : []
  const earlyPayOptions = config ? Object.entries(config.discounts.earlyPay) : []

  return <>
    <div className='step3'>
      <div className="formArea">
        <label className='formTitle'>Calculate Discount</label>

        {/* New family checkbox */}
        <div className='earlyPayDiscountArea'>
          <div className='checkboxArea'>
            <input
              type='checkbox'
              checked={familyInfo.isNewFamily}
              className='checkbox'
              onChange={() => updateFamilyInfo({ isNewFamily: !familyInfo.isNewFamily })}
            />
            <label
              className='checkmark'
              onClick={() => updateFamilyInfo({ isNewFamily: !familyInfo.isNewFamily })}
            />
          </div>
          <label className='fieldLabel' onClick={() => updateFamilyInfo({ isNewFamily: !familyInfo.isNewFamily })}>Check if you are a NEW Liberty Lake family</label>
        </div>

        {/* Occupation dropdown */}
        <div className="inputFieldArea" style={{ marginTop: '20px', width: '100%' }}>
          <label className='fieldLabel'>Are you active military or one of the following occupations?</label>
          <div
            className="selectInputFieldArea"
            style={{ width: '380px' }}
            onClick={() => showOccupationDropdown(true)}
          >
            {familyInfo.occupation.length > 0 ? familyInfo.occupation : 'Select...'}
            <img className='arrowIcon' src={arrowRight} />
          </div>
          {familyInfo.occupation !== 'None' && familyInfo.occupation.length > 0 && (
            <label className='helpText'>
              * {+((config?.discounts.occupational[familyInfo.occupation] || 0) * 100).toPrecision(10)}% discount will be applied for: {familyInfo.occupation}
            </label>
          )}
          {occupationDropdown && (
            <div className="dropdownContainer">
              {occupationOptions.map((occupation, index) => (
                <div
                  className='dropdownOption'
                  key={`${occupation}:${index}`}
                  onClick={() => {
                    updateFamilyInfo({ occupation })
                    showOccupationDropdown(false)
                  }}
                >
                  {occupation}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Early pay dropdown */}
        <div className="inputFieldArea" style={{ marginTop: '20px', width: '100%' }}>
          <label className='fieldLabel'>Choose a Pay in Full Date</label>
          <div
            className="selectInputFieldArea"
            style={{ width: '380px' }}
            onClick={() => showEarlyPayDropdown(true)}
          >
            {familyInfo.earlyPayOption.length > 0 ? familyInfo.earlyPayOption : 'Select...'}
            <img className='arrowIcon' src={arrowRight} />
          </div>
          {earlyPayDropdown && (
            <div className="dropdownContainer">
              <div
                className='dropdownOption'
                onClick={() => {
                  updateFamilyInfo({ earlyPayOption: '' })
                  showEarlyPayDropdown(false)
                }}
              >
                Select...
              </div>
              {earlyPayOptions.map(([option, amount], index) => (
                <div
                  className='dropdownOption'
                  key={`${option}:${index}`}
                  onClick={() => {
                    updateFamilyInfo({ earlyPayOption: option })
                    showEarlyPayDropdown(false)
                  }}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
    {(occupationDropdown || earlyPayDropdown) && <div className='backDrop' onClick={() => {
      showOccupationDropdown(false)
      showEarlyPayDropdown(false)
    }} />}
  </>
}

export default Step3
